module.exports = __webpack_public_path__ + "img/health-white.2f2438c1.png";